<template>
    <div class="g-fullscreen g-flexbox g-flex-direction-column error">
        <div v-if="error.statusCode !== 200" class="error__code">
            {{ error.statusCode }}
        </div>
        <div class="error__message">
            {{ error.message || error.statusText || '网络错误，请稍后重试。' }}
        </div>
        <nuxt-link
            class="error__home"
            to="/">
            回到首页
        </nuxt-link>
    </div>
</template>

<script>
export default {
    props: ['error'],
};
</script>

<style lang="scss">
.error {
    align-items: center;
    justify-content: center;
    z-index: 100;
    background: #000000;

    &__code {
        font-size: 1rem;
        margin-bottom: 0.5rem;
    }

    &__message {
        text-align: center;
        font-size: 0.2rem;
        margin: 0 1rem;
    }

    &__home {
        display: block;
        text-align: center;
        line-height: .5rem;
        width: 2rem;
        font-size: 0.18rem;
        color: #ffffff;
        background-color: #ffae00;
        text-decoration: none;
        border-radius: .02rem;
        margin-top: 0.3rem;
    }
}
</style>
